export default {"src":"/_next/static/media/icon-rating-star.b063917a.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};